import React, { useState, useEffect } from "react";
import { MDBTable, MDBSpinner, MDBBadge } from "mdb-react-ui-kit";
import { Link } from "react-router-dom";
import axios from "axios";

const DraftProductsPage = () => {
  const [drafts, setDrafts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const companyId = localStorage.getItem("company_id");
  const token = localStorage.getItem("token");

  useEffect(() => {
      // eslint-disable-next-line react-hooks/exhaustive-deps
    fetchDrafts();
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchDrafts = async () => {
    if (!companyId) {
      setError("Company ID not found");
      setLoading(false);
      return;
    }

    try {
      const response = await axios.get(
        `https://crosslisting-backend-aacranbzdyd3ffbd.centralindia-01.azurewebsites.net/api/drafts/${companyId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.success) {
        setDrafts(response.data.data);
      } else {
        setError(response.data.error || "Failed to load drafts");
      }
    } catch (err) {
      console.error("Draft fetch error:", err);
      setError(err.response?.data?.error || err.message);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="text-center py-5">
        <MDBSpinner role="status">
          <span className="visually-hidden">Loading...</span>
        </MDBSpinner>
      </div>
    );
  }

  if (error) {
    return (
      <div className="alert alert-danger m-4" role="alert">
        {error}
      </div>
    );
  }

  if (drafts.length === 0) {
    return (
      <div className="text-center py-5">
        <h4>No Draft Products Found</h4>
        <p className="text-muted">
          You haven't saved any draft products yet.
          <br />
          <Link to="/products/add" className="btn btn-primary mt-3">
            + Create New Product
          </Link>
        </p>
      </div>
    );
  }

  return (
    <div className="container-fluid px-4 py-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2>Draft Products</h2>
        <Link to="/products/add" className="btn btn-red">
          + New Product
        </Link>
      </div>

      <MDBTable hover responsive>
        <thead>
          <tr>
            <th>ID</th>
            <th>Title</th>
            <th>SKU</th>
            <th>Price</th>
            <th>Quantity</th>
            <th>Images</th>
            <th>Created At</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {drafts.map((draft) => (
            <tr key={draft.id}>
              <td>{draft.id}</td>
              <td>{draft.title || "Untitled"}</td>
              <td>
                <MDBBadge color="secondary" pill>
                  {draft.sku}
                </MDBBadge>
              </td>
              <td>${draft.price}</td>
              <td>{draft.quantity}</td>
              <td>
                {draft.images && draft.images.length > 0 ? (
                  <img
                    src={draft.images[0]}
                    alt="thumbnail"
                    style={{ width: 40, height: 40, objectFit: "cover", borderRadius: 4 }}
                  />
                ) : (
                  "No image"
                )}
              </td>
              <td>{new Date(draft.created_at).toLocaleDateString()}</td>
              <td>
                <Link
                  to={`/products/update/${draft.id}`}
                  className="btn btn-sm btn-primary me-2"
                >
                  Edit & Continue
                </Link>
                <Link
                  to={`/products/${draft.id}`}
                  className="btn btn-sm btn-outline-secondary"
                >
                  View
                </Link>
              </td>
            </tr>
          ))}
        </tbody>
      </MDBTable>
    </div>
  );
};

export default DraftProductsPage;